import { ROLE } from "@highnote/server/src/core/entities";

export const getRoleSummary = (
  roles: ROLE[] = [],
  fromMobileApp: boolean = false,
) => {
  if (!roles) return "No access";
  if (roles.includes(ROLE.ADMIN) || roles.includes(ROLE.MANAGE)) {
    return `Can manage, comment, reply,${fromMobileApp ? " react," : ""} upload, and download`;
  }

  const verbs = [];

  if (roles.includes(ROLE.COMMENT)) verbs.push("comment");
  if (roles.includes(ROLE.REPLY)) verbs.push("reply");
  if (fromMobileApp && roles.includes(ROLE.REACT)) verbs.push("react");
  if (roles.includes(ROLE.UPLOAD)) verbs.push("upload");
  if (roles.includes(ROLE.DOWNLOAD)) verbs.push("download");

  if (verbs.length === 0 && roles.includes(ROLE.VIEW)) {
    return "Can only view";
  }

  if (verbs.length === 0) return "No access";
  if (verbs.length === 1) return `Can only ${verbs[0]}`;
  if (verbs.length === 2) return `Can ${verbs[0]} and ${verbs[1]}`;
  return `Can ${verbs.slice(0, -1).join(", ")}, and ${verbs[verbs.length - 1]}`;
};
